"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var language = _ref.language;
  return language;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvbGFuZ3VhZ2UuanMiXSwibmFtZXMiOlsibGFuZ3VhZ2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7ZUFBZTtBQUFBLE1BQUdBLFFBQUgsUUFBR0EsUUFBSDtBQUFBLFNBQWtCQSxRQUFsQjtBQUFBLEMiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCAoeyBsYW5ndWFnZSB9KSA9PiBsYW5ndWFnZTtcbiJdfQ==